export default "__VITE_ASSET__KHyn5ind__"